export default __webpack_public_path__ + "static/media/bitchute-logo.0893319d.png";